var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"observerElement"},[_c('video',{ref:"videoElement",staticClass:"video-js",attrs:{"preload":"auto","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.source,"type":"application/x-mpegURL"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }